/** A paper trade's proving status, read from its label (rai.proving.status.card_label):
 * "Platform paper trade · <status> · not a call or recommendation". */
export type Proving = {
  kind: "proven" | "failed" | "testing";
  /** "Proven" | "Not proven" | "Testing" */
  title: string;
  /** e.g. "412 trades since 2021 · t 2.6 · win 58%" or "lost money in its history test" */
  detail: string;
};

const PREFIX = "Platform paper trade · ";
const SUFFIX = " · not a call or recommendation";

export function parseProving(label: string | null | undefined): Proving {
  let s = (label ?? "").trim();
  if (s.startsWith(PREFIX)) s = s.slice(PREFIX.length);
  if (s.endsWith(SUFFIX)) s = s.slice(0, -SUFFIX.length);
  if (s.startsWith("Proven")) {
    return {
      kind: "proven",
      title: "Proven",
      detail: s.replace(/^Proven\s*(·\s*)?/, ""),
    };
  }
  if (s.startsWith("Not proven yet") || !s) {
    return { kind: "testing", title: "Testing", detail: "not proven yet" };
  }
  if (s.startsWith("Not proven")) {
    return {
      kind: "failed",
      title: "Not proven",
      detail: s.replace(/^Not proven\s*(·\s*)?/, ""),
    };
  }
  return { kind: "testing", title: "Testing", detail: s };
}
